<template>
  <div class="sign">
    <div class="signContent">
      <div v-if="isDisabled"><img
          :src="dataForm.signatureImageShow" width="100%" height="310px" /></div>
      <div v-else class="wrap" @click.prevent="close_txt" @touchstart.prevent="close_txt">
        <VueSignaturePad v-if="stepActive == 2" class="signature" width="100%" height="310px" :disabled="isDisabled"
          ref="signaturePad" :options="options" />
        <span v-if="is_show" class="signature_txt">签 字 区 域</span>
      </div>
      <div class="tip">请在上方区域书写您的签名</div>
      <div class="block">
        <div class="tip1">注意：</div>
        <div class="tip1">1、必须签署真实姓名</div>
        <div class="tip1">2、尽量连续写完，避免无法签完姓名全称</div>
      </div>
      <div class="check">
        <van-checkbox v-model="checkbox" shape="square" checked-color="#D62D27" :disabled="isDisabled"></van-checkbox>
        <div class="fw">我已阅读并确认遵守<span @click="watchCN">《入学承诺书》</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadPictures, getFileUrl } from "@/api/common/index"// 上传
import tools from '../../../utils/tools'
import { submitData } from '@/api/home'
import { getStudentInfo } from '@/api/login'
import { Toast } from 'vant'
import Mixins from "../Home/component/location";
export default {
  name: "Sign",
  data() {
    return {
      // checkbox: false,
      is_show: true,
      checkbox: false,
      isDisabled: false, // 是否禁用
      isSubmitting: false, // 是否正在提交中
      options: {
        penColor: "#333",
        disabled: true
      },
      dataForm: {
        openId: '',
        isSignature: 0, // 1是已签名，0是未签名
        signatureImage: null,
        regAddress: "",
        signAddress: "",
      },
    };
  },
  props: ['openId', 'stepActive'],
  watch: {
    stepActive: {
      handler(newValue) {
        if (newValue == 2) {// 第二步
          this.initFn()
        }
      },
      deep: true,
      setImmediate: true
    },
  },
  mixins: [Mixins],
  created() {
    
  },
  methods: {
    initFn() {
      this.dataForm.openId = this.openId
      if (this.$store.state.userId) {
        this.dataForm.studentId = this.$store.state.userId
      }
      if (this.$store.state.token) {
        this.getStudentInfoFn()
      }
    },
    getStudentInfoFn() {
      getStudentInfo().then(res => {
        if (res && res.signatureImage) {
          getFileUrl({ objectKey: res.signatureImage }).then(datas => {
            this.isDisabled = !(
              res.approvalStatus == 0 || 
              res.approvalStatus == 1 ||
              res.approvalStatus == 3 ||
              res.approvalStatus == 6 ||
              res.approvalStatus == 9
            );
            this.checkbox = this.isDisabled
            res.signatureImageShow = datas
            Object.assign(this.dataForm, res)
          })
        }
      })
    },
    close_txt() {
      this.is_show = false;
    },
    // 清除重签
    clickReplay() {
      this.$refs.signaturePad.clearSignature();
      this.dataForm.isSignature = 0
      this.dataForm.signatureImage = ''
    },
    // 入学承诺
    watchCN() {
      this.$router.push({ name: 'accept' })
    },
    // 提交
    onSubmit() {
      // 防止重复提交
      if (this.isSubmitting) {
        return Promise.resolve();
      }
      // 签名板未渲染（如已签名/审核中的禁用状态）时，saveSignature 会同步抛错导致按钮点死
      if (!this.$refs.signaturePad) {
        this.$toast({
          message: "签名板未就绪，请刷新页面重试",
          position: 'top'
        });
        return Promise.resolve();
      }
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.$toast({
          message: "签名不能为空",
          position: 'top'
        });
        return Promise.resolve();
      }
      if (!this.checkbox) {
        this.$toast({
          message: "请勾选并确保遵守《入学承诺书》",
          position: 'top'
        });
        return Promise.resolve();
      }
      this.isSubmitting = true;
      return new Promise((resolve, reject) => {
        let uploadStarted = false;
        const startUpload = () => {
          if (uploadStarted) return;
          uploadStarted = true;
          // startUpload 由 setTimeout / 微信回调异步触发，不在 Promise 上下文内，
          // 低版本微信内核上 dataURLtoFile（new File/atob）可能同步抛错，
          // 不兜住会导致 isSubmitting 永久置位、无任何提示、按钮点死
          try {
            this.dataForm.signAddress = this.dataForm.area || "";
            this.uploadImg(data, resolve, reject);
          } catch (e) {
            this.isSubmitting = false;
            console.error('签名数据处理失败:', e);
            this.$toast({
              message: "签名数据生成失败，请重试",
              position: 'top',
              duration: 3000,
            });
            reject(e);
          }
        };
        // 尝试获取位置信息，获取成功后提交
        try {
          this.getLocation(startUpload);
        } catch (e) {
          // 获取位置失败，直接提交
          startUpload();
        }
        // 兜底：如果 2 秒内 getLocation 未回调（如非微信环境/低版本内核定位失败），直接提交
        setTimeout(() => {
          startUpload();
        }, 2000);
      });
    },
    // 上传图片
    uploadImg(data, resolve, reject) {
      let formData = new FormData();
      let file = tools.dataURLtoFile(data, `${Date.now()}.jpg`)
      formData.append("files", file);
      formData.append("token", this.$store.state.token);
      uploadPictures(formData).then((res) => {
        this.dataForm.isSignature = 1
        this.dataForm.signatureImage = res[0]
        return submitData(this.dataForm);
      }).then(res => {
        // 提交成功
        this.isSubmitting = false;
        Toast({
          message: "提交成功！",
          position: 'top',
          icon: 'success',
        });
        localStorage.clear();
        resolve();
        this.$router.push({ name: 'success' })
      }).catch(error => {
        // 提交失败，显示具体错误
        this.isSubmitting = false;
        console.error('签名提交失败:', error);
        // 优先使用后端返回的错误信息
        let errorMsg = "提交失败，请稍后重试";
        if (error) {
          if (error.msg) {
            errorMsg = error.msg;
          } else if (error.message) {
            // 区分网络错误和接口错误
            if (error.message === 'Network Error') {
              errorMsg = "网络连接失败，请检查网络后重试";
            } else if (error.message.indexOf('timeout') !== -1) {
              errorMsg = "请求超时，请稍后重试";
            } else if (error.message.indexOf('500') !== -1) {
              errorMsg = "服务器异常，请稍后重试";
            } else if (error.message.indexOf('404') !== -1) {
              errorMsg = "接口不存在，请联系管理员";
            } else {
              errorMsg = error.message;
            }
          }
        }
        Toast({
          message: errorMsg,
          position: 'top',
          duration: 3000,
        });
        reject(error);
      });
    },
    // 上一步
    prevClick() {
      this.stepActive--
    }
  },
};
</script>
<style scoped>
.van-cell {
  width: 50px;
}

.signContent {
  min-height: 100vh;
  padding: 20px 10px 60px;
  box-sizing: border-box;
}
</style>
<style lang='stylus' scoped>
@import '~@/assets/style/customize.styl';

.sign {
  width: 100%;
  .wrap {
    background: #f5f5f5;
    overflow: hidden;
    border: 1px solid #D9D8D8;
    border-radius: 10px;
    padding: 8px;
    position: relative;

    .signature {
      height: 100%;
      border: 1px solid #D9D8D8;
      border-radius: 10px;
      box-sizing: border-box;
      background: #fff;
    }

    .signature_txt {
      position: absolute;
      text-align: center;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      font-size: 40px;
      color: #dbdada;
      user-select: none;
    }
  }

  .tip {
    margin-top: 10px;
    text-align: center;
    font-size: 12px;
    color: #999;
  }

  .block {
    margin-top: 20px;
    font-size: 13px;
    color: #333333;
    line-height: 18px;
  }

  .check {
    margin-top: 20px;
    display: flex;
  }
  .check /deep/ .van-checkbox__icon {
    font-size: 14px;
    border-radius: 2px;
    overflow: hidden;
  }

  .fw {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 18px;
    margin-left: 10px;
    span {
      color: red;
    }
  }
}
</style>
